module.exports = __webpack_public_path__ + "img/crema y ovulos vaginales.a1575dc0.png";